import { useMutation } from '@tanstack/react-query';
import { useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import routesPath from '@/shared/constants/routesPath';

import Button from '@/components/ui/button';
import { InputWithLabel } from '@/components/ui/input';
import { ChangePassword } from '@/services/auth';
import { useTrackPageView } from '@/services/track';

const ResetPassword = () => {
  useTrackPageView();
  // get token from url
  const token = useParams().token;
  const navigate = useNavigate();

  const { mutate: changePassword } = useMutation({
    mutationFn: ChangePassword,
    onSuccess: () => navigate(routesPath.HOME),
  });

  const { handleSubmit, getFieldProps } = useFormik({
    initialValues: {
      newPassword: '',
      confirmNewPassword: '',
    },
    validationSchema: Yup.object({
      newPassword: Yup.string().required('New password is required'),
      confirmNewPassword: Yup.string()
        .required('Confirm new password is required')
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
    }),
    onSubmit: (values) => changePassword({ ...values, token }),
  });

  return (
    <div className="mx-auto flex flex-col items-center gap-8">
      <h1 className="text-center text-[48px]">Create new password</h1>

      <form
        className="mx-auto mt-9 flex max-w-[400px] flex-col items-center gap-8"
        onSubmit={handleSubmit}
      >
        <p className="text-center text-[16px]">
          Please provide a new password for your account
        </p>

        <InputWithLabel
          label="New password"
          name="newPassword"
          type="password"
          placeholder="Enter your new password"
          {...getFieldProps('newPassword')}
        />

        <InputWithLabel
          label="Confirm new password"
          name="confirmNewPassword"
          type="password"
          placeholder="Confirm your new password"
          {...getFieldProps('confirmNewPassword')}
        />

        <Button variant="primary" type="submit">
          Create new password
        </Button>
      </form>
    </div>
  );
};

export default ResetPassword;
